var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 23.25C16.5863 23.25 16.25 23.5863 16.25 24C16.25 24.4137 16.5863 24.75 17 24.75C17.4137 24.75 17.75 24.4137 17.75 24C17.75 23.5863 17.4137 23.25 17 23.25ZM14 24C14 22.3437 15.3437 21 17 21C18.6563 21 20 22.3437 20 24C20 25.6563 18.6563 27 17 27C15.3437 27 14 25.6563 14 24ZM24.5 23.25C24.0863 23.25 23.75 23.5863 23.75 24C23.75 24.4137 24.0863 24.75 24.5 24.75C24.9137 24.75 25.25 24.4137 25.25 24C25.25 23.5863 24.9137 23.25 24.5 23.25ZM21.5 24C21.5 22.3437 22.8437 21 24.5 21C26.1563 21 27.5 22.3437 27.5 24C27.5 25.6563 26.1563 27 24.5 27C22.8437 27 21.5 25.6563 21.5 24ZM32 23.25C31.5863 23.25 31.25 23.5863 31.25 24C31.25 24.4137 31.5863 24.75 32 24.75C32.4137 24.75 32.75 24.4137 32.75 24C32.75 23.5863 32.4137 23.25 32 23.25ZM29 24C29 22.3437 30.3437 21 32 21C33.6563 21 35 22.3437 35 24C35 25.6563 33.6563 27 32 27C30.3437 27 29 25.6563 29 24Z",
    fill: "#146EB4",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM24 1.73494C36.2966 1.73494 46.2651 11.7033 46.2651 24C46.2651 36.2966 36.2966 46.2651 24 46.2651C11.7033 46.2651 1.73494 36.2966 1.73494 24C1.73494 11.7033 11.7033 1.73494 24 1.73494Z",
    fill: "#146EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.c51f2373385558c8c14d5adb0cd3b8cf.svg";
export { ForwardRef as ReactComponent };